<template>
    <div class="topcode-wechat-order-item" @click="$router.push('/order/detail/' + order.id)">
        <div class="top">
            <div :class="'flex-center-y auto-width-8 state order-state-'+order.state">{{stateDICT}}</div>
            <div class="flex-center-y time ">{{order.createdTime}}</div>
        </div>
        <div class="body">
            <div class="content">
                <div class="flex-center-y left">
                    <img src="./images/order.png"/>
                    <div class="name">
                        <div class="title-small">{{order.name}}</div>
                        <div class="content">{{order.unitName}}</div>
                    </div>
                </div>
                <div class="flex-center right">
                    详情
                    <van-icon name="arrow"/>
                </div>
            </div>
            <div class="footer">
                <div>等级:<span :class="`order-level-${order.level}`">{{orderLevel}}</span></div>
                <div>类型:<span :class="`order-type-${order.type}`">{{orderType}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Cell, CellGroup, Icon, Tag} from "vant";

    import {downloadImg} from "@/config"
    import * as DICT from "@/utils/dict"

    export default {
        components: {
            Icon,
            CellGroup,
            Cell,
            Tag
        },
        props: {
            order: {type: Object, required: true},
        },
        data() {
            return {
                downloadImg
            };
        },
        computed: {
            stateDICT() {
                return DICT.getValue("ORDER_TSAK_STATE", this.order.state)
            },
            orderLevel() {
                return DICT.getValue("ORDER_TSAK_LEVEL", this.order.level)
            },
            orderType() {
                return DICT.getValue("ORDER_TSAK_TYPE", this.order.type)
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-order-item {
        width: 100%;
        margin-bottom: 8px;
        border-radius: 10px;
        border: 1px #cccccc solid;

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                justify-content: flex-end;

            }
            & > .state {
                height: 100%;
                /*width: 60px;*/
                border-radius: 8px 0px 0px 0px;
                /*justify-content: flex-end;*/
                justify-content: center;
            }
        }

        & > .body {
            display: flex;
            flex-direction: column;
            & > .content {
                /*padding: 8px;*/
                width: calc(100% - 10px);
                display: flex;
                & > .left {
                    padding: 5px;
                    display: flex;
                    width: 100%;
                    & > img {
                        width: 50px;
                        height: 50px;
                        /*background: #cccccc;*/
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 10px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }

                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    & > label {
                        width: 80px;
                        margin-left: 5px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
                & > .right {
                    width: 70px;
                    justify-content: flex-end;
                    color: #fa7d2d;
                    font-size: 14px;
                    font-weight: 500;
                }
            }
            & > .footer {
                border-top: 1px solid #bbb;
                width: 100%;
                height: 27px;
                display: flex;
                align-items: center;
                justify-content: space-around;
            }
        }
    }
</style>
